import React, {memo, useCallback, useState, useMemo, useEffect} from "react"
import {PasswordContainer} from "../../../../components/PasswordContainer"
import {SettingsPageContainer} from "../../../../components/Settings/SettingsPageContainer"
import {ColumnModel, SettingsList} from "../../../../components/Settings/SettingsList"
import {useLocalization} from "../../../../hooks/localization"
import {UserLogListType} from "../../../../store/control/state"
import {useSelector} from "react-redux"
import {useRPC} from "../../../../hooks/rpc"

const keyExtractor = (item: UserLogListType) => item.id
export const UserLogs = memo(function UserLogs() {
    const [rpc] = useRPC()
    const {t} = useLocalization()
    const userLogListSelector = useSelector(state => state.control.userLogList || null)
    const [systemInfo, setSystemInfo] = useState<UserLogListType[]>(userLogListSelector)
    useEffect(() => {
        rpc.GetUserLogList().then(r => setSystemInfo(r))
    }, [rpc])
    const newList = systemInfo.map(r => {
        const dateObject = new Date(r.timestamp * 1000)
        let yearString = dateObject.getFullYear().toString()
        if (yearString.length === 1) {
            yearString = "0" + yearString
        }
        let monthString = (dateObject.getMonth() + 1).toString()
        if (monthString.length === 1) {
            monthString = "0" + monthString
        }
        let dayString = dateObject.getDate().toString()
        if (dayString.length === 1) {
            dayString = "0" + dayString
        }
        let hourString = dateObject.getHours().toString()
        if (hourString.length === 1) {
            hourString = "0" + hourString
        }
        let minuteString = dateObject.getMinutes().toString()
        if (minuteString.length === 1) {
            minuteString = "0" + minuteString
        }
        const dateString = `${dayString}/${monthString}/${yearString} ${hourString}:${minuteString}`
        return {
            id: r.id,
            username: r.username,
            ip_address: r.ip_address,
            time: r.timestamp,
            timestamp: dateString
        }
    })
    const listSortedByTimestamp = newList.sort((a, b) => (a?.time < b?.time ? 1 : -1)).splice(0, 100)

    const [selectedControl, setSelectedControl] = useState<UserLogListType>(null)
    const displayNameExtractor = useCallback((item: UserLogListType, column: ColumnModel) => {
        if (column.key === "name") {
            return item
        }
        return item[column.key] || "-"
    }, [])

    const columns = useMemo<ColumnModel[]>(
        () => [
            {
                length: 1,
                name: t("time"),
                key: "timestamp"
            },
            {
                length: 1,
                name: t("username"),
                key: "username"
            },
            {
                length: 2,
                name: t("ip_address"),
                key: "ip_address"
            }
        ],
        [t]
    )

    return (
        <PasswordContainer requiredRole="admin" isFullscreen={true}>
            <SettingsPageContainer className="service-edit" buttons={[]} backUrl="/settings/logs" searchable={true}>
                <SettingsList
                    columns={columns}
                    items={listSortedByTimestamp}
                    listType="userLogList"
                    keyExtractor={keyExtractor}
                    displayNameExtractor={displayNameExtractor}
                    selectedItem={selectedControl}
                    onItemSelected={setSelectedControl}
                />
            </SettingsPageContainer>
        </PasswordContainer>
    )
})
